/* Mostrador de mensajes y errores */

const Alerts = ({loading, error=false, refetch=false }) => {

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading data...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger m-3" role="alert">
                <h4 className="alert-heading">Error loading data</h4>
                <p>{error}</p>
                <hr />
                <button className="btn btn-outline-danger" onClick={refetch}>
                <i className="bi bi-arrow-clockwise"></i> Refresh
                </button>
            </div>
        );
    }

};


export default Alerts;


